import * as React from 'react'
import { useCallback, useState, useEffect, useRef } from 'react'
import {
  listItemEndAdornmentStyle,
  listItemLabelStyle,
  getListItemStyles,
} from '../styling'
import { ProgressWidgetSvg } from '../svg/ProgressWidgetSvg'
import { Props } from './typings'
import ListItem from '@mui/material/ListItem'
import Tooltip from '@mui/material/Tooltip'
import { LightTooltip } from '@sales-center/components'

export const ProgressListItem: React.FC<Props> = (props: Props) => {
  // =========== M A T E R I A L   U I   S T Y L E ==========
  const listItemStyles = getListItemStyles({ marginLeft: props.marginLeft })

  // ========== S T A T E ==========
  const [color, setColor] = useState<string>(props.color)
  const [textIsTruncated, setTextIsTruncated] = useState<boolean>(false)
  const [textColor, setTextolor] = useState<string>(props.textColor)

  const textDivRef = useRef<HTMLDivElement | null>(null)

  // ========== H O O K S ==========
  useEffect(() => {
    setColor(props.color)
    setTextolor(props.textColor)
  }, [props.color, props.strokeColor, props.textColor])

  // ========== E V E N T S ==========
  const handleMouseOver = useCallback(() => {
    setColor(props.colorHover)
    setTextolor(props.textColorHover)
  }, [props.colorHover, props.textColorHover])

  const handleMouseOut = useCallback(() => {
    setColor(props.color)
    setTextolor(props.textColor)
  }, [props.color, props.textColor])

  useEffect(() => {
    if (textDivRef && textDivRef.current) {
      setTextIsTruncated(
        textDivRef.current.scrollWidth !== textDivRef.current.offsetWidth,
      )
    } else {
      setTextIsTruncated(false)
    }
  }, [])

  return (
    <LightTooltip title={textIsTruncated ? (props.text ?? '') : ''}>
      <ListItem
        sx={listItemStyles.root}
        onClick={props.onClick}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        data-test-id={props.dataTestId}
      >
        <ProgressWidgetSvg {...props} color={color} />
        {props.text && props.text.length && (
          <div
            ref={textDivRef}
            style={listItemLabelStyle(textColor, 33, props.padding)}
          >
            {textIsTruncated ? (
              <Tooltip title="test">
                <>{props.text}</>
              </Tooltip>
            ) : (
              props.text
            )}
          </div>
        )}
        {props.endAdornment !== undefined && (
          <div style={listItemEndAdornmentStyle(12, 2)}>
            {props.endAdornment(props.open)}
          </div>
        )}
      </ListItem>
    </LightTooltip>
  )
}

ProgressListItem.displayName = 'ProgressListItem'
